<template>
  <a class="google" href="/login?provider=google">
    <div class="img"><img src="../../assets/img/btn_google_light_normal.svg"></div>
    <div class="prompt">{{$t('index.login_prompt_google')}}</div>
  </a>
</template>

<script>
export default {
  props: {
    href: String
  },
};
</script>

<style lang="scss">
a.google {
  display: inline-flex;
  flex-direction: row;
  align-items: stretch;
  background-color: #ffffff;
  border-radius: 3px;
  box-shadow: 1px 1px 4px 1px #00000020;
  &:active {
    background-color: #4285F4;
    .img {
        background-image: url('../../assets/img/btn_google_light_pressed.svg');
        img {
            opacity: 0;
        }
    }
    .prompt {
        color: #FFFFFF;
    }
  }
  .img {
    margin: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 34pt;
      margin: 0px 0px;
    }
  }
  .prompt {
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    color: #757575;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8pt;
    padding-left: 16pt;
    white-space: nowrap;
  }
}
</style>
